import React, { Component } from 'react'
import { Table, Tooltip, Modal, Form, Button, Input, message, Select, Upload, Icon, Avatar, Badge, Switch } from 'antd'
import { connect } from 'dva'
import { Link } from 'dva/router'
import { all, create } from '../../services/restApi'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import config from '../../utils/config'
var IconAwesome = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const FormItem = Form.Item;
const TextArea = Input.TextArea;
const Option = Select.Option;
const ButtonGroup = Button.Group;

class Category extends Component {

	constructor (props) {
		super(props);

		this.state = {
			hotels: [],
            categories: [],
            query: {},
            imageUrl: '',
            file: {}
		};

		if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
			this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
	}


	/**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        // Query
        let query = {};
        if (this.state.currentHotel)
            query.objectId = this.state.currentHotel.objectId

        if (this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        // Consulta los hoteles
        all('TourCompany', {where: query, limit: 20}).then((resp) => {
            if (this.state.currentHotel) 
                this.props.form.setFieldsValue({hotel: {key: this.state.currentHotel.objectId, label: this.state.currentHotel.name}});

            this.setState({ hotels: resp.results });
        })

        this.firstLoad();
    }


    /**
    * Primera carga
    */
    firstLoad () {
        this.props.dispatch({ type: 'app/showLoadingTable' })

        let query = {};

        if (this.props.app.user.type === 'gerente') {
            query.hotel = {$in: this.props.app.user.hotels}
        }

        all('Category', {
            where: query,
            include: 'companies',
            skip: 0, 
            limit: this.props.category.limit,
            count: 1, 
            order: '-createdAt'
        }).then(resp => {

            if (resp.results.length > 0) {
            	
            	this.props.dispatch({ type: 'app/hideLoadingTable' })
                this.props.dispatch({type: 'category/queryFirst', payload: {
                    categories: resp.results, 
                    skip: 0, 
                    limit: this.props.category.limit,
                    total_items: resp.count,
                }})

            } else {
                this.props.dispatch({ type: 'app/hideLoadingTable' })
            }
        });
    }


    /**
    * Carga más registros
    */
    loadMore () {
    	if (this.props.category.skip < this.props.category.total_items) {
            this.props.dispatch({ type: 'app/showLoadingTable' })

    		let query = {...this.state.query};

            if (this.props.app.user.type === 'gerente') {
                query.hotel = {$in: this.props.app.user.hotels}
            }

            all('Category', {
                where: query,
                include: 'companies',
                skip: this.props.category.skip, 
                limit: this.props.category.limit,
                count: 1, 
                order: '-createdAt'
            }).then(resp => {

                if (resp.results.length > 0) {
                    let array = this.state.categories;
                    
                    this.setState({ categories: array.concat(resp.results) });

                    this.props.dispatch({type:'activity/querySuccess', 
                        payload: { categories: this.state.categories }
                    });
                    this.props.dispatch({type: 'app/hideLoadingTable'})

                } else {
                	this.props.dispatch({type: 'app/hideLoadingTable'})
                }
            });
    	}
    }


    getBase64 (img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    beforeUpload (file) {
        const isJPEG = file.type === 'image/jpeg';
        const isJPG = file.type === 'image/jpg';
        const isPNG = file.type === 'image/png';
        if (!isJPG && !isJPEG && !isPNG) {
            message.error('El formato de la imagen is inválido!');
        }

        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
            message.error('La imagen debe ser menor a 5MB!');
        }

        this.setState({file: file, loading: true});
        return (isJPG || isJPEG || isPNG) && isLt2M;
    }

    handleChange (info) {
        if (info.file.status === 'done') {
            this.getBase64(info.file.originFileObj, imageUrl => this.setState({ imageUrl }));
            this.setState({loading: false});
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchCompany (value, callback) {
        setTimeout(() => {
            all('TourCompany', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const companies = [];
                
                results.forEach((r) => {
                    companies.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(companies);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectCompanyChange (value) {
        if (value && value.key && !value.label) {
            this.fetchCompany(value.key, (resp) => {
                this.setState({ companies: resp })
            });
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Categoría principal (Expense principal)
    */
    fetchExpense (value, callback) {

        if (this.props.form.getFieldValue('TourCompany')) {
            let query = {name: {$regex: '(?i)' + value}};
            query.hotel = {__type: 'Pointer', className: 'TourCompany', objectId: this.props.form.getFieldValue('TourCompany').key}

            setTimeout(() => {
                all('Category', {where: query}).then((d) => {
                    const results = d.results;
                    const categories = [];
                    
                    results.forEach((r) => {
                        categories.push({
                            objectId: r.objectId,
                            name: r.name,
                        });
                    });

                    callback(categories);
                });
            }, 500);
        }
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectExpenseChange (value) {
        if (value && value.key && !value.label) {
            this.fetchExpense(value.key, (resp) => {
                this.setState({ categories: resp })
            });
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el hotel!');
        } else {
            // Consulta las categorías principales del hotel en el select
            all('Category', {
                where: {
                    type: 'principal', 
                    hotel: {__type: 'Pointer', className: 'TourCompany', objectId: value.key}
                }, 
                limit: 20
            }).then((resp) => {
                this.setState({ categories: resp.results });
            })

            this.search(value)
            callback();
        }
    }

    /**
    * Validator: Checa que se haya elegido un movimiento principal de la lista
    */
    checkType (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija la categoría principal!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkPrice (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');
        } else {
            callback();
        }
    } 


    /**
    * Búsqueda
    */
    search (value) {
        let query = this.state.query;
        query.type = 'principal';

        // Query
        if (value && value.key) {
            query.hotel = {__type: 'Pointer', className: 'TourCompany', objectId: value.key};
        }

        this.setState({query: query});
        this.props.dispatch({ type: 'app/showLoadingTable' })
        this.props.dispatch({type:'category/filterSuccess', 
            payload: {
                categories: [], 
                limit: 0, 
            }
        });

        all('Category', {
            where: query,
            include: 'TourCompany', 
            skip: 0, 
            limit: this.props.category.limit,
            count: 1, 
            order: '-createdAt'
        }).then(resp => {

            if (resp.results.length > 0) {
                const categories = [];
                resp.results.map((item, key) => {

                    return all('Category', {
                        where: {
                            parent_category: {__type: 'Pointer', className: 'Category', objectId: item.objectId}
                        },
                        include: 'hotel,parent_category'
                    }).then(expenses => {
                        if (expenses.results.length > 0)
                            item.children = expenses.results;

                        categories.push(item);

                        if (key === resp.results.length - 1) {

                            setTimeout(function() {
                                this.props.dispatch({ type: 'app/hideLoadingTable' })
                                this.props.dispatch({type: 'category/filterSuccess', payload: {
                                    categories: categories, 
                                    skip: 0, 
                                    limit: this.props.category.limit,
                                    total_items: resp.count,
                                }})
                            }.bind(this), 100);
                        }
                    });
                });
            } else {
                this.props.dispatch({ type: 'app/hideLoadingTable' })
            }
        });
    }


    /**
    * Elimina un registro
    */
    delete_item (item) {
    	this.setState({currentItem: ''});
    	let dispatch = this.props.dispatch

        if (this.state.currentHotel)
            this.props.form.resetFields(['name', 'description']);
        else
            this.props.form.resetFields();

    	confirm({
	    	title: '¿Estás seguro que deseas eliminar el registro?',
	      	onOk () {
	        	dispatch({type: 'category/removeItem', payload: item});
	      	}
	    })
    }


    /**
    * Establece el registro para editar
    */
    setUpdate (item) {
    	this.setState({currentItem: item.objectId});

        let obj = {...item};
        
        if (obj.companies && obj.companies.length > 0) {
            let companies = []
            obj.companies.map((item, key) => {
                companies.push({ key: item.objectId, label: item.name });

                if (key === obj.companies.length - 1) {
                    obj.companies = companies;
                }
            })
        }

        setTimeout(function() {
            this.props.form.setFieldsValue(obj);
            window.scrollTo(0, 0)
        }.bind(this), 100);
    }


    /**
    * Cancela la edición
    */
    cancel_update () {
        this.setState({currentItem: ''});
                                                    
        if (this.state.currentHotel)
            this.props.form.resetFields(['name', 'description']);
        else
            this.props.form.resetFields();
    }


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {...values};
            data.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};
            data.companies = [];
            data.active = true;

            values.companies.map(item => {
                data.companies.push({ __type: 'Pointer', className: 'TourCompany', objectId: item.key });
            })

            if (this.state.file.uid) 
                data.picture = this.state.file.uid + '.jpg';
            
            if (!this.state.currentItem) {
                // CREA
                
                this.props.dispatch({type: 'app/showButtonLoading'})

                create('Category', data).then(resp => {

                	_.extend(data, resp);

                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    message.success('Se ha creado el registro exitosamente');

                    this.props.dispatch({type: 'category/createSuccess', payload: data})
                    this.firstLoad();

                    this.props.form.resetFields(['name', 'companies', 'description']);
                    this.setState({ file: {}, imageUrl: '' });

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                data.objectId = this.state.currentItem;

                this.props.dispatch({type: 'category/update', payload: data})
                this.firstLoad();

                this.setState({ currentItem: '', file: {}, imageUrl: '' });
                this.props.form.resetFields(['name', 'companies', 'description']);
            }
        })
    }

    render () {
    	const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)
        const expenses_options = this.state.categories.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

	    return (
	        <div className="content-wrapper">
	            <section className="content-header">
	            	<h1>Categorías</h1>
	            </section>

	            <section className="content">
	            	<div className="row">
		            	<div className="col-md-3">
			                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>

			                	<div className="box-body">
	                            	<Form onSubmit={this.handleSubmit.bind(this)}>
		                                <div className="row">
		                                	{this.state.currentItem
		                                        ? <div className="col-md-12">
		                                            Status: <FormItem hasFeedback>
		                                                {this.props.form.getFieldDecorator('active')(
		                                                    <Switch checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} checked={this.props.form.getFieldValue('active')} />
		                                                )}
		                                            </FormItem>
		                                        </div>
		                                        : ''
		                                    }

		                                	<div className="col-md-12">
				                                <label>Imagen destacada</label>
				                                <Upload
				                                    className="avatar-uploader"
				                                    name="file"
				                                    accept="image/*"
				                                    showUploadList={true}
				                                    action={config.externalUrl + "includes/upload.php"}
				                                    beforeUpload={this.beforeUpload.bind(this)}
				                                    onChange={this.handleChange.bind(this)}
				                                    headers={{
				                                        "X-Parse-Application-Id": config.appId
				                                    }}
				                                    data={{
				                                        type: 'activity',
				                                        custom_name: this.state.file.uid + '.jpg'
				                                    }}
				                                >
				                                    {this.state.imageUrl ?
				                                        <img src={this.state.imageUrl} alt="" className="avatar" /> :
				                                        this.state.loading ? 
				                                            <Icon name="refresh" spin className="spin-uploader" />
				                                            : <Icon type="plus" className="avatar-uploader-trigger" />
				                                    }
				                                </Upload>
				                            </div>

                                            <div className="col-md-12">
			                                    <FormItem label="Empresas" hasFeedback>
			                                        {this.props.form.getFieldDecorator('companies', {
			                                            rules: [{
			                                                required: true,
			                                                message: 'Por favor, elija al menos un hotel'
			                                            }]
			                                        })(
			                                            <Select 
			                                                size='large'
			                                                mode="tags"
			                                                onChange={this.handleSelectCompanyChange.bind(this)}
			                                                filterOption={false}
			                                                labelInValue={true}
			                                                optionLabelProp='label'
			                                                >
			                                                {hotel_options}
			                                            </Select>
			                                        )}
			                                    </FormItem>
			                                </div>

                                            <div className="col-md-12">
                                                <FormItem label="Nombre" hasFeedback>
                                                    {this.props.form.getFieldDecorator('name', {
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, ingrese el nombre de la categoría'
                                                        }]
                                                    })(<Input size='large' placeholder="Nombre de la categoría" />)}
                                                </FormItem>
                                            </div>

		                                    <div className="col-md-12">
		                                    	<FormItem label="Breve descripción">
	                                        		{this.props.form.getFieldDecorator('description')(<TextArea rows={4} />)}
	                                    		</FormItem>
	                                    	</div>
		                                </div>

			                            <div className="row text-center paddingBottom30">
			                                <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'} style={{marginRight: '10px'}}>
			                                    {!this.state.currentItem ? 'Guardar' : 'Actualizar'}
			                                </Button>

			                                {this.state.currentItem
			                                	? <Button type='danger' onClick={this.cancel_update.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
				                                    Cancelar
				                                </Button>
				                                : ''
			                                }
			                            </div>
				                    </Form>
			                    </div>

			                </div>
			            </div>

			            <div className="col-md-9">
			                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>

			                	<div className="box-body">
	                            	<div className="table-responsive table">

		                            	<InfiniteScroll
										    padding={50}
									        throttle={100}
									        onScroll={() => this.loadMore()}>

		                                    <Table 
		                                    	dataSource={this.props.category.categories} 
		                                    	rowKey="objectId" size="middle" 
		                                    	loading={this.props.app.loadingTable} 
		                                    	pagination={false}>
		                                    	
		                                        <Column key="picture" render={(item) => (
                                                    <span>
                                                        {(item.children && item.children.length === 0) || !item.children
                                                            ? <span>
                                                                {!item.picture ?
                                                                    <Avatar shape="square" size="large" src="assets/img/noimage.png" /> :
                                                                    <Avatar shape="square" size="large" src={config.externalUrl + 'uploads/activities/' + item.picture} style={{borderColor: item.color, borderWidth: '2px'}} />
                                                                }
                                                            </span>
                                                            : ''
                                                        }
                                                    </span>
                                                )} />
                                                <Column title="Nombre" dataIndex="name" key="name" />
                                                <Column width={350} title="Descripción" key="description" render={(item) => (
                                                    <small>{item.description}</small>
                                                )} />
                                                <Column title="Empresas" key="companies" render={(item) => (
                                                    <span>
                                                        {item.companies && item.companies.map(d => <span key={d.objectId}>{d.name},<br /></span>)}
                                                    </span>
                                                )} />
                                                <Column title="Status" key="active" render={(item) => (
		                                        	<span>
                                                        {item.active
                                                        	? <span><Badge status="success" /><small>Activo</small></span>
                                                            : <span><Badge status="warning" /><small>Inactivo</small></span>
                                                        }
                                                    </span>
		                                        )}/>
                                                <Column width={90} title="Acciones" key="action"
                                                    render={(item) => (
                                                        <span className="actions">
                                                            <ButtonGroup>
                                                                <Tooltip placement="bottom" title="Editar">
                                                                    <Button>
                                                                        <Link onClick={() => { this.setUpdate(item) }}><IconAwesome name="edit" /></Link>
                                                                    </Button>
                                                                </Tooltip>

                                                                {(item.children && item.children.length === 0) || !item.children
                                                                    ?<Tooltip placement="bottom" title="Eliminar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.delete_item(item) }} className=""><IconAwesome name="trash" /></Link>
                                                                        </Button>
                                                                    </Tooltip>
                                                                    : ''
                                                                }
                                                            </ButtonGroup>
                                                        </span>
                                                    )}
                                                />
		                                    </Table>        
			                            </InfiniteScroll>
		                            </div>
			                    </div>

			                </div>
			            </div>
			        </div>
	            </section>
	        </div>
	    )
	}
}

export default connect(({category, app}) => ({category, app}))(Form.create()(Category))


// WEBPACK FOOTER //
// ./src/components/activities/categories.js